function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.625 0.95H4.375C3.46663 0.95 2.59547 1.31085 1.95316 1.95316C1.31085 2.59547 0.95 3.46663 0.95 4.375V15.625C0.95 16.5334 1.31085 17.4045 1.95316 18.0468C2.59547 18.6892 3.46663 19.05 4.375 19.05H12.443C13.053 19.05 13.6381 18.8076 14.0694 18.3763L18.3763 14.0693C18.5899 13.8558 18.7593 13.6022 18.8749 13.3232C18.9905 13.0441 19.05 12.7451 19.05 12.443V4.375C19.05 3.46663 18.6892 2.59547 18.0468 1.95316C17.4045 1.31085 16.5334 0.95 15.625 0.95ZM17.2883 13.425L13.425 17.2883V14.5001C13.4253 14.215 13.5387 13.9418 13.7402 13.7402C13.9418 13.5387 14.215 13.4253 14.5001 13.425H17.2883ZM17.825 12.2H14.5C13.89 12.2 13.305 12.4423 12.8737 12.8737C12.4423 13.305 12.2 13.89 12.2 14.5V17.825H4.37506C3.79177 17.8243 3.23257 17.5923 2.82012 17.1799C2.40768 16.7674 2.17567 16.2082 2.175 15.6249V4.37506C2.17566 3.79177 2.40766 3.23256 2.82011 2.82011C3.23256 2.40766 3.79177 2.17566 4.37506 2.175H15.6249C16.2082 2.17566 16.7674 2.40766 17.1799 2.82011C17.5923 3.23256 17.8243 3.79177 17.825 4.37506V12.2Z",
  fill: "#703965",
  stroke: "#703965",
  strokeWidth: 0.1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9375 5.45H6.0625C5.90006 5.45 5.74426 5.51453 5.6294 5.6294C5.51453 5.74426 5.45 5.90006 5.45 6.0625C5.45 6.22494 5.51453 6.38074 5.6294 6.4956C5.74426 6.61047 5.90006 6.675 6.0625 6.675H13.9375C14.0999 6.675 14.2557 6.61047 14.3706 6.4956C14.4855 6.38074 14.55 6.22495 14.55 6.0625C14.55 5.90005 14.4855 5.74426 14.3706 5.6294C14.2557 5.51453 14.0999 5.45 13.9375 5.45Z",
  fill: "#703965",
  stroke: "#703965",
  strokeWidth: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9375 8.825H6.0625C5.90006 8.825 5.74426 8.88953 5.6294 9.0044C5.51453 9.11926 5.45 9.27506 5.45 9.4375C5.45 9.59994 5.51453 9.75574 5.6294 9.8706C5.74426 9.98547 5.90006 10.05 6.0625 10.05H13.9375C14.0999 10.05 14.2557 9.98547 14.3706 9.8706C14.4855 9.75574 14.55 9.59995 14.55 9.4375C14.55 9.27505 14.4855 9.11926 14.3706 9.0044C14.2557 8.88953 14.0999 8.825 13.9375 8.825Z",
  fill: "#703965",
  stroke: "#703965",
  strokeWidth: 0.1
});

var SvgNote = function SvgNote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/note.07c26c95.svg";
export { ForwardRef as ReactComponent };